
import { Vue, Component } from 'vue-property-decorator'

@Component
export default class GuaranteeDetail extends Vue {
  handleBack() {
    this.$router.go(-1)
  }
  created() {
    console.log('guaranteeId',this.$route.query.guaranteeId);
  }
}
